import React from "react"

export default function Blog027() {
  return (
    <section>
    <article>
    <h2>27. 12-12-2022</h2>
          <h3>React and Next.js</h3>
          <p>
          <strong>Hello!</strong>
          <br /><br />
          My name is Eric Polley. I am a programmer at ericpolley.com <br />
         I have recorded a vlog video talking about my progress as a Software Engineer. If you would like a visual form of this information, 
         I provided the link in the Links section of this blog post. <br /> <br />
         I have spent most of November putting together authentication websites with a variety of methods. I started with Strapi and Next.js, 
         I tried Snipcart with Hygraph, and React with Firebase. <br />
         The Firebase website is a Realator.com replica. This website has functionality to Sign up, Sign in, Sign out, Change user name, 
         Access profile after Log-in, and the ability to add, edit, and post housing rentals and sales. <br /> <br />
         I am currently working on a few tutorials replicating large well known website with Next.js and Firebase. Those websites being Google, 
         Twitter, IMDB, and Instagram. I am currently using googles console to log in to a website, in the google replica tutorial. 
         <br />
         I have been applying consistently to jobs that I have found to be a good fit. I have had a few interviews now, and I am confident 
         my full time role as a Software Engineer is right around the corner. 
         <br />
         <br />
         Thank you for reading! I know it has been a minute since I have updated the blog, and I kept this post rather short. 
         I have been learning a lot of the back-end navigation and linking. These are the kind of updates you spend a few hours on, 
         and your website looks exactly the same. This makes showing progress challenging, aside from peering into github. 
         <br />
         So, as I dive into connecting the API to websites creating carts and authentication, it will take a bit of time before I create my own shop 
         and add it to my portfolio or main website. I will update here when the time comes. Until then..
         <br />
         <br />
         Thanks for reading, <br />
         ~ Eric Polley


         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="https://www.youtube.com/watch?v=0yb1NETX0pA"
              title="Shop!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>5 Month Vlog</p></strong></a
            >
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
